import styled from 'styled-components';

interface CardProps {
  disabled: boolean;
}

export const CardContainer = styled.div`
  box-shadow: 0px 3px 6px #00000029;
  height: 149px;
  width: 225px;
  border-radius: 5px;
`;

export const CardHeader = styled.div`
  background: #e6e6e6;
  height: 11%;
  box-shadow: 0px -2px 6px #00000029;
  border-radius: 5px 5px 0 0;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;

export const CardContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
  height: 89%;
`;

export const CardDescription = styled.div`
  display: flex;
  align-items: center;
  height: 20%;
  padding: 0 18px 0 18px;
  width: 100%;

  span {
    color: #1a1a1a;
    font-weight: bold;
    width: 193px;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;

  button {
    border-radius: 50%;
    border: none;
    width: 32px;
    height: 32px;
    background: white;
    box-shadow: 0px 3px 6px #00000029;
  }
`;

export const RequestButton = styled.button`
  width: 193px;
  height: 32px;
  background: none;
  border: 1px solid #eb0045;
  font-weight: bold;
  color: #eb0045;
  opacity: ${({ disabled }: CardProps) => (disabled ? 0.5 : 1.0)};
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const FavoriteButton = styled.button`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
`;
